// extracted by mini-css-extract-plugin
module.exports = {"selectWidget":"SelectWidget_selectWidget__2vNWi"};